var map = {
	"./accompaniment.json": 4669,
	"./ai-coach.json": 9983,
	"./dongyinlv.json": 7120,
	"./drums.json": 1328,
	"./footprint.json": 4498,
	"./guitar.json": 2852,
	"./guzheng.json": 9731,
	"./lesson.json": 6368,
	"./metronome.json": 3875,
	"./piano.json": 198,
	"./score.json": 3715,
	"./shike-shouhu.json": 8944,
	"./teleprompter.json": 2178,
	"./text-extractor.json": 8045,
	"./theory.json": 9923,
	"./tuner.json": 3229,
	"./ukulele.json": 6800,
	"./violin.json": 454,
	"./vocal.json": 7299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1360;